var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product-item',
};
document.addEventListener("DOMContentLoaded", function() {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', function(event) {
  initGrid();
});


var fetchProductCardHTML = function(handle) {
  var productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      var text = res;
      var parser = new DOMParser();
      var htmlDocument = parser.parseFromString(text, 'text/html');
      var productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
      
      if (productCard) {
        var existingBtn = productCard.querySelector(selectors.button);
        if (existingBtn) existingBtn.remove();
        
        var trashBtn = document.createElement('button');
        trashBtn.setAttribute('type', 'button');
        trashBtn.setAttribute('button-wishlist', '');
        trashBtn.setAttribute('data-product-handle', handle);
        trashBtn.className = 'wishlist-trash-btn btn-icon-s';
        trashBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                              <path d="M15.0859 16.3818C15.0391 16.8969 14.607 17.2919 14.0898 17.292H5.91602C5.39887 17.2919 4.96674 16.8969 4.91992 16.3818L4.16992 8.125H15.8359L15.0859 16.3818ZM8.33594 8.95801C7.87585 8.95818 7.50293 9.33186 7.50293 9.79199V15.625C7.50293 16.0851 7.87585 16.4578 8.33594 16.458C8.79617 16.458 9.16992 16.0852 9.16992 15.625V9.79199C9.16992 9.33175 8.79617 8.95801 8.33594 8.95801ZM11.6699 8.95801C11.2097 8.95801 10.8359 9.33175 10.8359 9.79199V15.625C10.8359 16.0852 11.2097 16.458 11.6699 16.458C12.13 16.4578 12.5029 16.0851 12.5029 15.625V9.79199C12.5029 9.33186 12.13 8.95818 11.6699 8.95801ZM15.8359 5.625C16.2961 5.625 16.6697 5.99792 16.6699 6.45801C16.6699 6.91825 16.2962 7.29199 15.8359 7.29199H4.16992C3.70968 7.29199 3.33594 6.91825 3.33594 6.45801C3.33611 5.99792 3.70979 5.625 4.16992 5.625H15.8359ZM11.6699 3.125C12.1299 3.12518 12.5028 3.49803 12.5029 3.95801C12.5029 4.41814 12.13 4.79182 11.6699 4.79199H8.33594C7.87585 4.79182 7.50293 4.41814 7.50293 3.95801C7.50311 3.49803 7.87596 3.12518 8.33594 3.125H11.6699Z" fill="#312B36"/>
                              </svg>`;
        
        trashBtn.style.cssText = '';
        
        var trashWrapper = document.createElement('div');
        trashWrapper.className = 'wishlist-trash-wrapper';
        trashWrapper.appendChild(trashBtn);
        
        productCard.style.position = 'relative';
        productCard.appendChild(trashWrapper);
      }

      return productCard ? productCard.outerHTML : '';
    })
    .catch((err) => {
      console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err);
      return '';
    });
};

var setupGrid = async function(grid) {
  var wishlist = getWishlist();
  var emptyState = document.querySelector('.wishlist-empty-state');
  var populatedState = document.querySelector('.wishlist-populated-state');

  if (wishlist.length === 0) {
    if (emptyState) emptyState.style.display = 'block';
    if (populatedState) populatedState.style.display = 'none';
    grid.innerHTML = '';
    grid.classList.add(GRID_LOADED_CLASS);
  } else {
    if (emptyState) emptyState.style.display = 'none';
    if (populatedState) populatedState.style.display = 'block';
    var requests = wishlist.map(fetchProductCardHTML);
    var responses = await Promise.all(requests);
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();
  }

  var event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

var setupButtons = function(buttons) {
  buttons.forEach(function(button) {
    if (button.dataset.wishlistInitialized) return;
    button.dataset.wishlistInitialized = 'true';

    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');

    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);

    button.addEventListener('click', function() {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

var initGrid = function() {
  var grid = document.querySelector(selectors.grid);
  if (grid) setupGrid(grid);
};

var initButtons = function() {
  var buttons = document.querySelectorAll(selectors.button);
  if (buttons.length) setupButtons(buttons);
  else return;
  
  var event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

var getWishlist = function() {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function(array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  var event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

var updateWishlist = function(handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.unshift(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function(handle) {
  var wishlist = getWishlist();
  return wishlist.includes(handle);
};

var resetWishlist = function() {
  return setWishlist([]);
};